<template>
    <div class="job-index-search container main--content-header">
        <div class="job-index-search--container row">
            <div class="job-index-search--search col-12 col-lg-5">
                <search-input-component
                    placeholder="Search"
                    :emit_instead="true"
                    class="job-index-search--search-input"
                    @submit="submit()"
                    :search="search_edit"
                    v-model="search_edit"
                ></search-input-component>
            </div>

            <div class="job-index-search--filters col-12 col-lg-7">
                <div class="row">
                    <div class="job-index-search--filters-filter col-12 col-md-6">
                        <label class="job-index-search--filters-filter-label">Show</label>
                        <select v-model="show_filter_edit" v-on:change="submit()" class="job-index-search--filters-filter-select form-control">
                            <option value="active">All Active</option>
                            <option value="inactive">All Inactive</option>
                        </select>
                    </div>
                    <div class="job-index-search--filters-filter col-12 col-md-6">
                        <label class="job-index-search--filters-filter-label">Sort By</label>
                        <select v-model="sort_by_edit" v-on:change="submit()" class="job-index-search--filters-filter-select form-control">
                            <option value="created_at">Created At</option>
                            <option value="start_date">Start Date</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
	import SearchInputComponent from "../general_components/SearchInputComponent";
	export default {
		name: "JobIndexSearch",
		components: {SearchInputComponent},
        props: [
        	'show_filter',
            'sort_by',
            'search'
        ],

        data(){
			return {
				show_filter_edit: '',
				sort_by_edit: '',
				search_edit: '',
            }
        },

        beforeMount() {
			this.show_filter_edit = this.show_filter || 'active';
			this.sort_by_edit = this.sort_by || 'created_at';
			this.search_edit = this.search || '';
		},

        methods: {
			submit(page = 1){
                this.$emit('getting-data', true);
				let _q = window.location.href;
				_q = _q.substr(0, _q.indexOf('?'));

				_q = _q + '?search=' + this.search_edit + '&sort_by=' + this.sort_by_edit + '&show_filter=' + this.show_filter_edit + '&page=' + page;

                $.ajax({
                    type: 'GET',
                    url: _q,
                    success: function(data){
                        return data;
                    }
                }).then((result) => {
                    this.$emit('getting-data', false);
                    this.$emit('new-data', result);
                    this.updatePageTitle(result.active_jobs, result.ended_jobs);
                }).catch((err) => {
                    console.log(err);
                });
            },

            updatePageTitle(active, ended) {
                let label = 'Projects';
                if (this.show_filter_edit === 'active') {
                    label = active ? `${active} Project` + (active > 1 ? 's' : '') + ' active' : 'No active projects';
                }
                else if (this.show_filter_edit=== 'inactive') {
                    label = ended ? `${ended} Project` + (ended > 1 ? 's' : '') + ' inactive' : 'No inactive projects';
                }

                $('#page_title')[0].innerHTML = label;
            }
        }
	}
</script>
